import React, { Component } from "react";
import moment from "moment";
import axios from "axios";
import Modal from "react-modal";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { MdClose } from "react-icons/md";
import config from "../../../../config";

import errorFunctions from "../../../../store/errorFunctions";
Modal.setAppElement("body");
export default class NoteItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditNote: false,
      showEditMedia: false,
      showActivities: true,
      showNotes: true,
      editedNoteId: "",
      delNoteId: "",
      addedNote: "",
      editedNote: "",
      mediaTypeWarning: "",
      showDueDateChangeModal: false,
      showLogs: false,
    };
    this.handleBtnClick = this.handleBtnClick.bind(this);
  }
  deleteCommercialNotes() {
    this.props
      .protectedFetch(config.backendServer + `commercial-note/${this.state.delNoteId}`, "DELETE", null, errorFunctions.checkResponseSent)
      .then((res) => {
        this.props.retrieveCommunication();
        this.setState({
          showDeleteNote: false,
          isLoading: false,
          commercialNotes: res || [],
        });
      });
    // this.props.retrieveWarranty();
  }
  handleBtnClick = () => {
    if (this.props.note.list_media?.length > 0) {
      const imgArray = this.props.note.media?.split("/");
      const imgName = imgArray?.length > 0 ? imgArray[imgArray.length - 1] : imgArray;
      this.setState({
        showEditMedia: true,
        mediaNotes: this.props.note.media,
        editedNoteId: this.props.note.id,
        editedNote: imgName,
      });
    } else {
      this.setState({
        showEditNote: true,
        editedNote: this.props.note.detail,
        editedNoteId: this.props.note.id,
      });
    }
  };
  handleInputChange = (e) => {
    const { id, value } = e.target;
    this.setState({
      [id]: value,
    });
  };

  handleEditNote = () => {
    let formData = new FormData();
    formData.append("note", this.state.editedNote);
    this.addNote(formData);
  };
  handleFileUpload = (e) => {
    // TODO - verify file upload to make sure it's good
    const file = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "video/mp4", "video/webm", "video/quicktime"];

    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG, PNG, WEBM , MOV and MP4 files are allowed.");
      this.setState({ allowUpload: false });
    } else {
      this.setState({ allowUpload: true });
    }
    const media = document.getElementById("uploadNoteMedia").files[0];
    this.setState({
      mediaNotes: media,
      dueDateType: "media",
      fileName: file.name,
    });
  };

  handleEditMedia = () => {
    if (this.state.allowUpload && this.state.mediaNotes) {
      this.setState({ loading: true, showAddMedia: false });
      let formData = new FormData();
      formData.append("media", this.state.mediaNotes);
      formData.append("note", this.state.mediaNotes.type);
      this.addNote(formData);
    } else {
      this.setState({ loading: false, showAddMedia: true });
    }
  };

  handleEdit = (edit) => {
    console.log(edit);
    this.setState({ editedNote: edit });
  };

  addNote(formData) {
    const token = this.props?.userInfo?.access_token;
    let options = {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
    };

    const url = `${config.backendServer}ticket/${this.props.ticketId}/commercial_note/`;
    axios
      .put(url, formData, options)
      .then(() => {
        this.setState({
          addedNote: "",
          editedNoteId: "",
          editedNote: null,
          showAddNote: false,
          showAddMedia: false,
          disableBtnNote: false,
          isLoading: false,
          showEditNote: false,
          selectedLogs: [],
        });
        this.props.retrieveCommunication();
      })
      .catch(() => {
        this.setState({ showEditNote: false });
      });
    this.props.retrieveCommunication();
  }

  render() {
    return (
      <div>
        <div key={this.props.note.created} className="card mb-2" data-testid={`activity-${this.props.note.created}`}>
          <div style={{ padding: "3px", margin: "1px" }} className={"bg-lite row  rounded-top"}>
            <div className="col-8 ">
              <span className="text-info mr-3">{this.props.note.email}</span>
              <span className="text-secondary">{moment(this.props.note.created).format("DD MMMM YYYY HH:mm")}</span>
            </div>
            <div className="col-4 text-end"></div>
          </div>
          <div className="card-body">
            <div className="row d-flex justify-content-left">
              <div dangerouslySetInnerHTML={{ __html: this.props.note.note }} />
            </div>
            <small>
              <div className="d-flex gap-2">
                <button className="btn bg-light text-dark btn-sm" onClick={() => this.props.replyNote(this.props.note.id)}>
                  Reply
                </button>
                {/* <button
                  className="btn bg-light text-dark  btn-sm"
                  onClick={() => this.setState({ delNoteId: this.props.note.id, showDeleteNote: true })}
                >
                  Delete
                </button> */}
              </div>
            </small>
          </div>
        </div>
        {this.props.note.child &&
          this.props.note.child?.map((nt) => (
            <div key={nt.created} className="card mb-2 ml-5" data-testid={`activity-${nt.created}`}>
              <div style={{ padding: "3px", margin: "1px" }} className={"bg-lite row  rounded-top"}>
                <div className="col-8 ">
                  <span className="text-primary mr-3">{nt.email}</span>
                  <span className="text-secondary">{moment(nt.created).format("DD MMMM YYYY HH:mm")}</span>
                </div>
                <div className="col-4 text-end"></div>
              </div>
              <div className="card-body">
                <div className="row d-flex">
                  <div dangerouslySetInnerHTML={{ __html: nt.note }} />
                </div>
                {/* <small>
                  <div className="d-flex justify-content-between">
                    <button className="btn bg-light text-dark  btn-sm" onClick={() => this.setState({ delNoteId: nt.id, showDeleteNote: true })}>
                      Delete
                    </button>
                  </div>
                </small> */}
              </div>
            </div>
          ))}
        <Modal isOpen={this.state.showEditNote} contentLabel={"Add Note"} className={"input-modal w-25 h-50 "}>
          <div className="card  h-100">
            <button data-testid={"closeModal"} onClick={() => this.setState({ showEditNote: false })} className={"confirm-modal-close"}>
              <MdClose />
            </button>
            <div className={"card-header"}>{`${this.state.showEditNote ? "Edit" : "Add"} Note`}</div>
            <div className="card-body overflow-auto">
              <ReactQuill
                value={this.state.addedNote || this.state.editedNote || ""}
                onChange={(val) => this.setState({ editedNote: val })}
                id={"editedNote"}
              />
            </div>
            <div className="card-footer">
              <button
                data-testid={"saveNote"}
                disabled={this.state.disableBtnNote}
                type="button"
                className={"btn btn-outline-primary mr-3"}
                onClick={() => this.handleEditNote()}
              >
                Save
              </button>
              <button
                data-testid={"cancelNote"}
                type={"button"}
                className={"btn btn-outline-secondary"}
                onClick={() => this.setState({ showEditNote: false, addedNote: "" })}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
        <Modal isOpen={this.state.showDeleteNote} contentLabel={"Delete Communication"} className={"input-modal  "}>
          <div className="card  h-100">
            <button data-testid={"closeModal"} onClick={() => this.setState({ showDeleteNote: false })} className={"confirm-modal-close"}>
              <MdClose />
            </button>
            <div className={"card-header"}>{`Delete Communication`}</div>
            <div className="card-footer">
              <button
                data-testid={"saveNote"}
                disabled={this.state.disableBtnNote}
                type="button"
                className={"btn btn-outline-primary mr-3"}
                onClick={() => this.deleteCommercialNotes()}
              >
                Delete
              </button>
              <button
                data-testid={"cancelNote"}
                type={"button"}
                className={"btn btn-outline-secondary"}
                onClick={() => this.setState({ showDeleteNote: false, addedNote: "" })}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
